import da from "./da.json";
import en from "./en.json";
import nb from "./nb.json";
import sv from "./sv.json";

export const languages = {
  da,
  en,
  nb,
  sv,
};
